module.exports = __webpack_public_path__ + "img/12.58d93f2d.jpg";